import {use} from 'react';

import {VehicleCreate} from '../components/VehicleCreate';
import {TVehicleCreateContext} from '../contexts/TVehicleCreateContext';

export const useVehicleCreateContext = (): TVehicleCreateContext => use(VehicleCreate);
